// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"f6c7136f","376":"201292ff","585":"9d8c1945","831":"0ca311a7"}[chunkId] + ".chunk.js";
};